import { render, staticRenderFns } from "./SmartPoints.vue?vue&type=template&id=be4ca0e6"
import script from "./SmartPoints.vue?vue&type=script&lang=js"
export * from "./SmartPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports